"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find.js");

require("core-js/modules/es6.array.filter.js");

require("core-js/modules/es7.object.values.js");

require("core-js/modules/es6.object.keys.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _logoDove = _interopRequireDefault(require("../../../images/logo-dove.png"));

require("../../../sass/shared/elements/Loader.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoaderComponent = function LoaderComponent(props) {
  // default is true for active
  var _props$fetchingProps = props.fetchingProps,
      fetchingProps = _props$fetchingProps === void 0 ? {} : _props$fetchingProps,
      _props$active = props.active,
      active = _props$active === void 0 ? true : _props$active;
  var shouldRender = Object.values(fetchingProps).filter(Boolean).find(function (prop) {
    return prop.isFetching;
  });

  var Loader = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('loader-component', {
      active: active
    })
  }, /*#__PURE__*/_react.default.createElement("svg", {
    height: "40",
    width: "40",
    className: "circular"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "40",
    cy: "40",
    r: "32",
    fill: "none",
    strokeWidth: "3",
    strokeMiterlimit: "10",
    className: "path"
  })), /*#__PURE__*/_react.default.createElement("img", {
    className: "logo",
    src: _logoDove.default,
    alt: ""
  }));

  var renderContent = function renderContent() {
    if (Object.keys(fetchingProps).length) return shouldRender ? Loader : null;
    return Loader;
  };

  return renderContent();
};

LoaderComponent.propTypes = {
  fetchingProps: _propTypes.object,
  active: _propTypes.bool
};
var _default = LoaderComponent;
exports.default = _default;